<template>
  <div class="contact-info">
    <a class="email" href = "mailto: info@bodymachinebody.com">info@bodymachinebody.com</a>
    <a href="https://www.facebook.com/bodymachinebody/" target="_blank">
      <img class="facebook-logo" alt="Facebook" src="../assets/facebook_icon.png">
    </a>
  </div>
</template>

<script>
  export default {
    name: "Contact"
  }
</script>

<style scoped>
  .contact-info {
    height: 25vh;
    background-color: #0d2f39;
    width: 70%;
    margin: 30px auto 50px;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    align-content: center;
  }

  .email {
    color: white;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 18px;
  }

  .facebook-logo {
    height: 40px;
    width: 40px;
  }

</style>